import React from 'react';

function ExnessBrokerAd() {
  return (
    <section className="py-16 px-6 bg-gradient-to-br from-zinc-950 via-black to-zinc-900 border-y border-zinc-800">
      <div className="max-w-7xl mx-auto">
        
        {/* Premium Badge */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500 to-yellow-600 px-4 py-2 rounded-full mb-4">
            <svg className="w-5 h-5 text-black" fill="currentColor" viewBox="0 0 20 20">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
            <span className="text-black font-bold text-sm uppercase tracking-wider">Official Kasango AI Pro Partner</span>
          </div>
        </div>

        <div className="bg-gradient-to-br from-zinc-900 to-black rounded-3xl overflow-hidden border border-zinc-800 shadow-2xl">
          <div className="grid md:grid-cols-2 gap-0">
            
            {/* Left Side - Exness Branding */}
            <div className="relative bg-gradient-to-br from-yellow-600 via-yellow-500 to-yellow-600 p-12 flex flex-col justify-center overflow-hidden">
              {/* Decorative Elements */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-400/20 rounded-full blur-3xl"></div>
              <div className="absolute bottom-0 left-0 w-48 h-48 bg-yellow-300/20 rounded-full blur-3xl"></div>
              
              <div className="relative z-10">
                {/* Exness Logo Placeholder */}
                <div className="mb-8">
                  <div className="inline-flex items-center gap-3 bg-black/80 backdrop-blur-sm px-6 py-3 rounded-xl">
                    <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
                      <span className="text-black font-black text-2xl">E</span>
                    </div>
                    <span className="text-white font-black text-3xl tracking-tight">EXNESS</span>
                  </div>
                </div>

                <h2 className="text-4xl md:text-5xl font-black text-black mb-4 leading-tight">
                  Trade with the<br />World's Best
                </h2>
                
                <p className="text-black/80 font-medium text-lg mb-6">
                  The only broker officially recommended for Kasango AI Pro
                </p>

                {/* Trust Indicators */}
                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-black">
                    <div className="w-6 h-6 bg-black/80 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="font-bold">Regulated & Licensed Globally</span>
                  </div>
                  <div className="flex items-center gap-3 text-black">
                    <div className="w-6 h-6 bg-black/80 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="font-bold">Ultra-Fast Execution (0.1s)</span>
                  </div>
                  <div className="flex items-center gap-3 text-black">
                    <div className="w-6 h-6 bg-black/80 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-4 h-4 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                    <span className="font-bold">24/7 Multilingual Support</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Benefits & CTA */}
            <div className="p-12 flex flex-col justify-center bg-zinc-950">
              <h3 className="text-3xl font-light text-white mb-6">
                Why Exness for <span className="text-[#00FF7F] font-semibold">Kasango AI Pro?</span>
              </h3>

              <div className="space-y-6 mb-8">
                {/* Benefit 1 */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Instant Withdrawals</h4>
                    <p className="text-gray-400 text-sm">Get your profits instantly - no waiting, no delays</p>
                  </div>
                </div>

                {/* Benefit 2 */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Zero Commission Trading</h4>
                    <p className="text-gray-400 text-sm">Keep 100% of your Kasango AI profits</p>
                  </div>
                </div>

                {/* Benefit 3 */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">AI-Optimized Infrastructure</h4>
                    <p className="text-gray-400 text-sm">Built for automated trading systems like Kasango AI</p>
                  </div>
                </div>

                {/* Benefit 4 */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center flex-shrink-0">
                    <svg className="w-6 h-6 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-semibold mb-1">Unlimited Leverage (1:2000)</h4>
                    <p className="text-gray-400 text-sm">Maximize your trading potential with high leverage</p>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <a
                href="https://www.exness.com/?utm_source=partners&ex_ol=1"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-black font-bold text-lg rounded-xl transition-all duration-300 hover:scale-105 shadow-xl shadow-yellow-500/20 hover:shadow-2xl hover:shadow-yellow-500/40 overflow-hidden"
              >
                <span className="absolute inset-0 bg-white/20 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-500"></span>
                <span className="relative">Open Free Exness Account</span>
                <svg className="relative w-6 h-6 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </a>

              <p className="text-xs text-gray-500 mt-4 text-center">
                ⚡ Account opens in 2 minutes • Start trading with Kasango AI Pro immediately
              </p>
            </div>

          </div>
        </div>

        {/* Bottom Trust Bar */}
        <div className="mt-8 text-center">
          <div className="inline-flex flex-wrap items-center justify-center gap-6 text-sm text-gray-400">
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" />
              </svg>
              <span>$1 Minimum Deposit</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-zinc-700"></div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>18+ Years Experience</span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-zinc-700"></div>
            <div className="flex items-center gap-2">
              <svg className="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
              <span>Used by 10,000+ Kasango AI Traders</span>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default ExnessBrokerAd;
